import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2L2 22z"
}), 'SignalCellular0BarOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellular0BarOutlined.js
// module id = 6134
// module chunks = 2